import AdjustSmartBanner from '@adjustcom/smart-banner-sdk';

const analyticsCategory = {
    primaryCategory: 'site furniture',
    subCategory: 'adjust'
};

export const handleAdjustClick = () =>
    window?.dataLayer?.push({
        category: analyticsCategory,
        event: 'get the app banner - clicked',
        effect: 'get the app banner clicked'
    });

const handleAdjustImpression = () =>
    window?.dataLayer?.push({
        category: analyticsCategory,
        event: 'get the app banner - impression',
        effect: 'get the app banner viewed'
    });

const handleAdjustDismissed = () =>
    window?.dataLayer?.push({
        category: analyticsCategory,
        event: 'get the app banner - dismissed',
        effect: 'get the app banner dismissed'
    });

export const setDeepLink = () => {
    let fullPath = window.location.hostname + window.location.pathname;

    if (/ipad|iphone|ipod/.test(navigator?.userAgent?.toLowerCase())) {
        fullPath = window.location.pathname.slice(1);
    }

    const path = fullPath.startsWith('/') ? fullPath.slice(1) : fullPath;

    AdjustSmartBanner.setIosDeepLinkPath(path);
    AdjustSmartBanner.setAndroidDeepLinkPath(path);
};

export const onCreatedAdjust = () => {
    setDeepLink();
    AdjustSmartBanner.show();
    handleAdjustImpression();
    window.addEventListener('spa-navigation', setDeepLink);
    document.body.classList?.add?.('adjust-visible');

    const element = document.querySelector('[class^="adjust-sb_action"]');
    if (element) {
        element.href = element.href + '&adj_tracker_limit=250000';
    }

    if (window.SF?.notifyAdjustBannerOpened) {
        window.SF.notifyAdjustBannerOpened();
    }
};

export const onDismissedAdjust = () => {
    document.body.classList?.remove?.('adjust-visible');
    window.removeEventListener('spa-navigation', setDeepLink);
    handleAdjustDismissed();

    if (window.SF?.notifyAdjustBannerClosed) {
        window.SF.notifyAdjustBannerClosed();
    }
};

export default function configureAdjust(adjust, language) {
    const bannerParent = document.createElement('div');
    bannerParent.id = 'adjustContainer';
    document.querySelector('#header-main').prepend(bannerParent);

    AdjustSmartBanner.init({
        appToken: adjust.token,
        bannerParent,
        language,
        logLevel: adjust.logLevel,
        onCreated: onCreatedAdjust,
        onDismissed: onDismissedAdjust
    });
}
